import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propBoolField, propTextField } from "../../common/entityStoreForm";
import { propRequired } from "../../common/entityStoreValidators";
import { PaymentMethodDto } from "./types";
import { usePaymentMethods } from "../../common/enum";

export const PaymentMethodDialog = (props: {
    close: () => void;
    paymentMethod: PaymentMethodDto;
    onChange(): void;
}) => {
    const [useStore] = useState(() => createEntityStore<PaymentMethodDto>({
        data: props.paymentMethod,
        path: "settings/paymentMethods",
        fetchOnInit: false,
        id: props.paymentMethod.id,
        onSaved() {
            props.onChange();
            props.close();
            usePaymentMethods.getState().uninit();
        },
        propValidators: [
            propRequired("description"),
        ]
    }));

    const { save, isSaveDisabled } = useStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{`Edit payment method - ${props.paymentMethod.code}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={6}>{propTextField(useStore)("description", "Description")}</Grid>
                <Grid item xs={6}>{propBoolField(useStore)("active", "Active")}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} disabled={isSaveDisabled} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};